import angular from 'angular';

import { estClient } from '../services/api/estClient';
import { getSharedWorkspaceContext } from '../services/sharedWorkspace';
import currencyModule from './currency/currency.module';
import estI18nModule from './est.i18n.module';
import estThemeModule from './est.theme.module';
import estWebpackTemplateModule from './est.webpackTemplate.module';
import filtersModule from './filters/filters.module';
import momentModule from './moment/moment.module';

function config(cloudinaryProvider) {
  estClient.setCsrfToken(
    (angular.element('.token')[0] as HTMLInputElement | undefined)?.value ||
      getSharedWorkspaceContext()?.csrfToken ||
      null,
  );

  cloudinaryProvider.set('cloud_name', 'estoffice-com');
}

config.$inject = ['cloudinaryProvider'];

export default angular
  .module('est.globals', [
    'ngResource',
    'cloudinary',
    'ui.router',
    'perfect_scrollbar',
    'LocalStorageModule',
    estI18nModule.name,
    estThemeModule.name,
    filtersModule.name,
    estWebpackTemplateModule.name,
    momentModule.name,
    currencyModule.name,
  ])
  .config(config);
